import React, {useRef} from "react"
import {AllowedIncomingWiresColumns, IncomingWiresColumns} from "./IncomingWires.types"
import {Resource} from "../../resources/common"
import {useNavigateWithListPath} from "../../hooks/useListReturnPath"
import {IncomingWire} from "../../resources/incomingWire"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import {IncomingWireRow} from "./IncomingWireRow"

interface IncomingWiresTableProps {
	incomingWires: IncomingWire[]
	includedColumns: AllowedIncomingWiresColumns[]
	isUsingPaging: boolean
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	refresh: () => void
	include?: Resource[]
	fullHeight?: boolean
	stickyAction?: boolean
}

export function IncomingWiresTable({
	incomingWires,
	includedColumns,
	hasResults,
	isUsingPaging,
	hasPrev,
	hasNext,
	prev,
	next,
	refresh,
	include,
	fullHeight = true,
	stickyAction = true,
}: IncomingWiresTableProps) {
	const navigateWithListPath = useNavigateWithListPath()
	const noContent = incomingWires.length === 0
	const ref = useRef(null)

	return (
		<div ref={ref} className={"incoming-wires-table"}>
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyAction={stickyAction}
				noContentText={"No incoming wires found"}
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							if (column[1] === IncomingWiresColumns.createdAt) {
								return <DataTableCell key={column[1]}>{column[1]}</DataTableCell>
							}

							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{incomingWires.map((wire) => (
						<IncomingWireRow
							incomingWire={wire}
							key={wire.id}
							include={include}
							onClick={(e) => {
								e.preventDefault()
								e.stopPropagation()
								navigateWithListPath(`/incoming-wires/${wire.id}`)
							}}
							refresh={refresh}
							includedColumns={includedColumns}
						/>
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
			/>
		</div>
	)
}
